import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const sizeApi = createApi({
  reducerPath: 'sizeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Size'],
  endpoints: (builder) => ({
    getSizes: builder.query({
      query: (page = 1) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/size',
          method: 'GET',
          params: { page, 'access-token': token },
        };
      },
      providesTags: ['Size'],
    }),
    addSize: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/add-size',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Size'],
    }),
    updateSize: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/update-size',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Size'],
    }),
    deleteSize: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/delete-size',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Size'],
    }),
  }),
});

export const {
  useGetSizesQuery,
  useAddSizeMutation,
  useUpdateSizeMutation,
  useDeleteSizeMutation,
} = sizeApi;
